import { Component } from '@angular/core';
import { IosComingSoonDialogService } from '../../services/ios-coming-soon-dialog.service';

@Component({
  selector: 'app-ios-coming-soon-dialog',
  standalone: true,
  template: `
    @if (dialogService.isOpen()) {
      <div
        class="fixed inset-0 bg-black/50 flex items-center justify-center z-[100] p-4"
        (click)="dialogService.close()"
      >
        <div
          class="bg-white rounded-2xl w-full max-w-sm p-6 text-center shadow-xl"
          data-testid="ios-coming-soon-dialog"
          (click)="$event.stopPropagation()"
        >
          <div class="w-14 h-14 rounded-full bg-purple-50 flex items-center justify-center mx-auto mb-4">
            <svg class="w-7 h-7 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
          </div>

          <h3 class="text-lg font-semibold text-gray-900 mb-2">Continuum is coming soon to iOS.</h3>
          <p class="text-sm text-gray-600 mb-6">
            We’re putting the finishing touches on the iOS subscription experience. We’ll let you know when it’s ready.
          </p>

          <button
            type="button"
            (click)="dialogService.close()"
            class="btn-gradient w-full !py-2.5"
            data-testid="ios-coming-soon-dialog-close"
          >
            Got it
          </button>
        </div>
      </div>
    }
  `
})
export class IosComingSoonDialogComponent {
  constructor(public dialogService: IosComingSoonDialogService) {}
}
